<template>
  <div>
    <PageHeader title="Contact"></PageHeader>
    <v-card
      outlined
      class="vcardcontent"
       v-bind:class="{ 'version-spacing': !isLoggedIn }"
    >
      <v-card-text style="color:#ffffff;" class="honeyBold">
        <p>Contact us at support@fanhive.co.uk to submit your request to host a competition(s).</p>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';

export default {
  name: 'contact',
  data: () => ({
    numberOfFans: 1000,
    entryPrice: 2,
    incomePotential: 0,
    rules: {
      required: value => !!value || 'Required.'
    }
  }),
  components: {
    PageHeader
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    calculate: function () {

      if(this.numberOfFans > 0 && this.entryPrice > 0){
        var entryPence = this.entryPrice*100
        console.log(entryPence)
        var bankComm = entryPence * 0.02
        console.log(bankComm)
        var bankCharge = bankComm+23
        console.log(bankCharge)
        var z = entryPence - bankCharge
        console.log(z)
        this.incomePotential = ((this.numberOfFans * z)/100)*0.2
        console.log(this.incomePotential)
      } else {
        console.log('Values are invalid')
        console.log(this.numberOfFans)
        console.log(this.ent)
      }
    }
  },
  created () {
    this.calculate()
  }
}
</script>